import { authStore } from "@/routes/login/auth-store"
import { Link } from "react-router-dom"

const LogoPart = () => {
  const { role, scope_type } = authStore()

  const logoPath = role === "ADMIN" ? "/select" : scope_type === "group" ? "/select/apt" : null

  return (
    <Link className="flex items-center gap-2 cursor-pointer" to={logoPath}>
      <img src="/images/toicos-logo-a.png" alt="ToICoS" className="h-7 w-auto" />
      <h1 className="font-bold text-xl">미터링케어 서비스</h1>
    </Link>
  )
}

export default LogoPart
